import { DistributorAdminLocation } from "../_models/DistributorAdminLocation";

export class DistributorAdminLocationMapper {
    static allServerToLocal(serverLocations = []) {
        return serverLocations.map(this.serverToLocal);
    }

    static serverToLocal(serverLocation) {
        return DistributorAdminLocation({
            locationId: serverLocation.location_id,
            locationName: serverLocation.location_name,
            hasPremiumPlan: serverLocation.has_premium_plan,
            activeLicenseTypeUids: serverLocation.active_license_type_uids ?? [],
        });
    }
}
